<template>
  <div class="book-create container">
    <div v-if="supplier.id > 0 && branch.id > 0 && e1 === 1">
      <people-pass
        :reservation="reservation"
        :branch="branch"
        :hora="datahora"
        @changePerson="changePerson"
      />
      <date-pass
        :reservation="reservation"
        :branch="branch"
        :person="person"
        @nextPass="nextPass"
        @variabledia="variabledia"
        @variablehora="variablehora"
      />
    </div>
    <reason-pass
      v-if="e1 === 2"
      :reservation="reservation"
      :branch="branch"
      :fecha="fecha"
      @nextPass="nextPass"
    />
    <data-reserve v-if="e1 === 3" :reservation="reservation" :datahora="datahora" :fecha="fecha" :show_policies="show_policies" :branch="branch" @nextPass="nextPass" @clickAgreement="clickAgreement" @openPolites="openPolites" />
    <info-reserve
      v-if="e1 === 4"
      :reservation="reservation"
      :branch="branch"
      :instance="instance"
      :supplier="supplier"
      :agreement="checkPrivacitePolicities"
    />
  </div>
</template>

<script>
import { reservas } from "@/services/reservas";
import { track } from "../../services/track-custom";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import PeoplePass from "../../components/reserva/PeoplePass";
import DatePass from "../../components/reserva/DatePass.vue";
import ReasonPass from "../../components/reserva/ReasonPass.vue";
import DataReserve from "../../components/reserva/DataReserve.vue";
import InfoReserve from "../../components/reserva/InfoReserve.vue";

export default {
  name: "Book",
  components: {
    PeoplePass,
    DatePass,
    ReasonPass,
    DataReserve,
    InfoReserve
  },
  data() {
    return {
      e1: 1,
      personas:'',
      hora:'',
      datahora: '',
      fecha: { id:0 },
      branch: { id: 0 },
      reservation: {
        cuantos: 1,
        origin: "Cluvi",
        zone_id: null,
        siteservice_id: null,
        branch_id: 0,
        name: "",
        phone: "",
        email: "",
        observation: ""
      },
      person: null,
      checkPrivacitePolicities: true,
      show_policies: false
    }
  },
  watch: {
    openMenuTop() {
      this.validateTopMenu();
    }
  },
  computed:{
    ...mapState('customer', ["instance", "supplier"]),
    ...mapState('shared', ["openMenuTop"]),
    ...mapState('profile', ["profile"]),
    ...mapGetters('customer',['getLabels']),
    isArchis () {
      return this.instance.slug === 'archies' ? true : false;
    }
  },
  async created() {
    this.setBook();
    this.SetBookPurchaseId(null);
    this.TemplateActiveHeader({ header_type:"main"});
    this.setOpenMenuTop(false);
    this.SetAppClass("background-app");
    await this.GetSupplier(this.$route.params.supplier_id);
    this.getBranch();
    this.reservation.branch_id = this.supplier.branch_id;
  },
  mounted() {
    track.trackView(this, `Reservar`, `/${this.supplier.slug}/reservar`);
    track.trackEventCluvi({}, 'view book');
    if(!this.profile.phone_code && !this.profile.phone_code_iso2) {
      this.SetProfile({
        phone_code: this.instance.phone_code_without_plus,
        phone_code_iso2: this.instance.country_code
      });
    };
  },
  methods:{
    ...mapActions('customer', ["GetSupplier"]),
    ...mapMutations('template', ["SetLoading","TemplateActiveHeader", "SetAppClass"]),
    ...mapMutations('shared', ["setOpenMenuTop"]),
    ...mapMutations('bookings', ["SetBookPurchaseId"]),
    ...mapActions('order', ['setBook']),
    ...mapMutations('profile', ["SetProfile"]),
    clickAgreement(val) {
      this.checkPrivacitePolicities = val;
    },
    changePerson (val) {
      this.person = val;
    },
    validateTopMenu () {
      if(this.openMenuTop) {
        this.e1 = this.e1 - 1;
        if(this.e1 === 1) this.TemplateActiveHeader({ header_type:"main"});
        this.setOpenMenuTop(false);
      };
    },
    variabledia (item){
      this.fecha = item;
    },
    variablehora(item){
      this.hora = item.label;
      this.datahora = item;
      this.fecha.horaObj = this.datahora;
    },
    variableservicio(item){
      this.servicio = item.label;
    },
    nextPass(item) {
      if(item === 'paso2') {
        this.e1 = 2;
        this.TemplateActiveHeader({ header_type:"back_action"});
      } else if (item === 'paso3') {
        this.e1 = 3;
      } else if (item === 'paso4') {
        this.e1 = 4;
        this.TemplateActiveHeader({});
      } else {
        this.TemplateActiveHeader({ header_type:"main"});
      };
    },
    async getBranch() {
      try {
        const branchData = await reservas.getBranch(this.supplier.branch_id);
        if(branchData) {
          this.branch = branchData.data;
          this.branch.reasons_book.unshift(this.getLabels('UNSPECIFIED'))
          this.SetLoading(false);
        };
      } catch (error) {
        console.error(error);
      };
    },
    openPolites () {
      let url = this.isArchis ? 'https://archies.co/pages/politica_de_tratamiento_de_datos' : '/POLITICADETRATAMIENTODEDATOSPERSONALESCLUVISAS.pdf';
      window.open(url, '_blank');
    }
  },
  metaInfo() {
    return {
      title: `${this.$t('booking.book_on')} ${this.supplier.label}`
    }
  }
};
</script>

<style scoped lang="scss">
  .book-create {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
  }
</style>
